import { createContext, useContext } from 'react';

interface HomeModeContextType {
  isDark: boolean;
  setIsDark: (v: boolean | ((prev: boolean) => boolean)) => void;
}

export const HomeModeContext = createContext<HomeModeContextType>({
  isDark: true,
  setIsDark: () => {},
});

export function useHomeMode() {
  return useContext(HomeModeContext);
}
